<template>
  <section class="success-box">
    <img src="~images/finish.png" alt />
    <p class="finish-text">{{finishText}}</p>
    <p class="success-text">{{successText}}</p>
  </section>
</template>

<script>
export default {
  props: {
    finishText: {
      type: String,
      default: '',
    },
    successText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.success-box {
  text-align: center;
}
.finish-text {
  color: #0088ff;
  font-size: 24px;
  margin: 8px 0;
}
.success-text {
  padding: 16px 0;
}
</style>
